import apiHandler from "../core/apiHandler";

/**
 * 📅 API para el reporte de ventas diarias por grupo de productos
 * Endpoint: /api/reports/daily-group-sales
 */
const dailyGroupSalesReportApi = apiHandler("reports/daily-group-sales");

export default dailyGroupSalesReportApi;
